/* eslint-disable no-fallthrough */
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import moment from "moment";
import countryList from "react-select-country-list";
import placeholder from "../../assets/images/userprofile.png";
import { blobToFile, scrollToFirstError } from "../../utils/helpers";
import ImageCropper from "../../Component/ImageCropper";
import SkeletonLoader from "../UpdateProfile/skeltonLoader";
import queryString from "query-string";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { getSettingData } from "../../actions/settingActions";
import { getAllProgrammes } from "../../actions/userActions";
import {
  fetchUniversityPartners,
  fetchIndustries,
  fetchProgramStudies,
  fetchRegisterSettings,
  fetchAreas,
  fetchObjectives,
  fetchParticularPrograms,
  fetchLanguages,
  fetchExperience,
  fetchUserData,
  registerUser,
  fetchCoursesCompleted,
  fetchBoardExperienceMentor,
  fetchBoardEntityTypeExperience,
  fetchAccreditedDirector,
  fetchBoardExperienceLevel,
  fetchBoardExperience,
} from "../Authentication/Register/slice/registerSlice";

import {
  normalizeStudentSignupPayload,
  buildStudentSignupFormData,
} from "./helpers/studentSignupDataHelpers";

import { renderStudentSignupField, renderBoardRolesInline } from "./helpers/studentSignupFieldRenderers";
import { fetchSettings } from "../../store/slices/settingsSlice";

const StudentSignup = (props) => {
  const dispatch = useDispatch();

  // Component-specific loading state to prevent flash
  const [componentReady, setComponentReady] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  const {
    universityPartners: university_partners_list,
    industries: industry_list,
    programStudies: programStudyId,
    registerStepFields,
    areas,
    objectives: objective,
    particularPrograms: particularProgram,
    languages: languageOptions,
    experienceData: userExperience,
    coursesCompleted,
    boardExperienceMentor,
    boardEntityTypeExperience,
    accreditedDirector,
    boardExperienceLevel,
    boardExperience,
  } = useSelector((state) => state.register);

  const { setting } = useSelector((state) => state.settings);
  const programmes = useSelector((state) => state.programmes);

  let d = new Date();
  d.setMonth(d.getMonth() + 3);
  const nextThreeMonthData = d.toLocaleDateString();
  const location = useLocation();
  const history = useNavigate();

  const { title, superUserParams } = props;

  const [dob, setDob] = useState(null);
  const { register, handleSubmit, control, clearErrors, reset, setValue, watch, trigger, formState, formState: { errors } } = useForm({
    defaultValues: superUserParams,
    mode: "onSubmit",
    reValidateMode: "onChange",
  });

  const siteName = setting?.name?.trim() || "Register Now as Mentor or Mentee";

  useEffect(() => {
    const title = `${siteName} - Register Now as Mentor or Mentee`;

    document.title = title;

    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        `Register now with ${setting?.name} as a mentor or mentee to join the domain-specific career mentoring between women leaders and experienced industry leaders.`
      );
  }, [siteName, title]);

  useEffect(() => {
    dispatch(fetchSettings());
  }, []);

  const queryStringParsed = queryString.parse(location.search);
  const [roleId, setRoleId] = useState("");
  const [experience, setExperience] = useState([]);
  const [experienceData, setExperienceData] = useState([]);

  const [checkBox, setCheckBox] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [showDateDiv, setShowDateDiv] = useState("none");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState(nextThreeMonthData);
  const [emailVerifyString, setEmailVerifyString] = useState("");
  const [readOnly] = useState(false);
  const [industryData, setIndustryData] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [getLoader, setGetLoader] = useState(false);
  const [redirectPath, setRedirectPath] = useState(null);

  const customStyles = {
    menu: (base) => ({
      ...base,
      backgroundColor: "white",
      top: "32px",
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    }),
  };

  const [{ alt, src }, setImg] = useState({
    src: placeholder,
    alt: "Upload an Image",
  });
  const [cropImg, setCropImg] = useState("");
  const [cropImgModalShow, setCropImgModalShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const getUserId = localStorage.getItem("userId");
  const [userId, setUserId] = useState(localStorage.getItem("userId"));
  const options = countryList().getData();
  const [country] = useState(options);
  const [userData, setUserData] = useState({});
  const [mainArea, setMainArea] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedObjective, setSelectedObjective] = useState([]);
  const [selectedResume, setSelectedResume] = useState("");
  const [resumeText, setResumeText] = useState("");
  const availabilityChecked = watch("availability");

  const countWords = (text) => {
    return text?.replaceAll("\r\n", "\n")?.length;
  };

  useEffect(() => {
    dispatch(fetchUniversityPartners());
    dispatch(fetchIndustries());
    dispatch(fetchParticularPrograms());
    dispatch(fetchAreas());
    dispatch(fetchProgramStudies());
  }, [dispatch]);

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    new Array(currentYear - 1990 + 1),
    (_, index) => 1990 + index
  );

  const checkFromDate = (date) => {
    setFromDate(moment(new Date(date)).format("YYYY-MM-DD"));
  };
  const checkToDate = (date) => {
    setToDate(moment(new Date(date)).format("YYYY-MM-DD"));
  };
  const [email, setEmail] = useState(queryStringParsed.email);

  useEffect(() => {
    if (queryStringParsed.email) setValue("email", queryStringParsed.email);
    dispatch(fetchLanguages());
  }, [queryStringParsed.email, setValue, dispatch]);

  const terminateProcess = registerStepFields?.[0]?.terminate_process;

  useEffect(() => {
    if (formState.submitCount > 0 && Object.keys(errors).length > 0) {
      scrollToFirstError();
    }
  }, [formState.submitCount, errors]);

  const onSubmit = async (data) => {
    const empVal = (data.employee || watch("employee") || "")?.toLowerCase();
    if (empVal !== "yes" && empVal !== "no") {
      clearErrors(["employee_start_date", "employee_end_date"]);
      setValue("employee_start_date", "");
      setValue("employee_end_date", "");
      data.employee_start_date = "";
      data.employee_end_date = "";
    } else if (empVal === "yes") {
      clearErrors("employee_end_date");
      setValue("employee_end_date", "");
      data.employee_end_date = "";
    }
    const isValid = await trigger();
    if (!isValid) {
      scrollToFirstError();
      return;
    }
    const normalizedPayload = normalizeStudentSignupPayload({
      data,
      roleId,
      dob,
      email_verify_string: emailVerifyString,
      selectedResume,
    });


    const formData = buildStudentSignupFormData({
      data: normalizedPayload,
      registerStepFields,
      selectedFile,
    });

    setGetLoader(true);

    dispatch(
      registerUser({
        params: formData,
        roleId,
        userId,
        terminateProcess,
        step: "step_2",
        paramsLogin: null,
      })
    )
      .unwrap()
      .then((res) => {
        setGetLoader(false);

        if (!res) return;
        // Show popup instead of toaster
        setPopupMessage(res?.message);
        setShowPopup(true);
        // Store redirect path for later
        setRedirectPath(res.redirectTo);
      })
      .catch((error) => {
        setGetLoader(false);
        setPopupMessage(error?.message || "Registration failed");
        setShowPopup(true);
      });
  };

  const handlePopupOk = () => {
    setShowPopup(false);

    if (redirectPath) {
      history(redirectPath);
    }
  };

  const getExperienceData = () => {
    dispatch(fetchExperience());
  };

  const getObjectiveData = (roleID) => {
    dispatch(fetchObjectives(roleID));
  };

  const registerSetting = async (roleId1) => {
    dispatch(fetchRegisterSettings({ roleId: roleId1, stepKey: "step_2" }));
  };

  const handleChange = (item) => {
    getExperienceData();
    setRoleId(item);
    
    // Fetch board-related data based on role
    if (item === "Mentor" || item === "Mentees") {
      dispatch(fetchCoursesCompleted());
      dispatch(fetchBoardExperience(item));
      dispatch(fetchBoardExperienceLevel(item));
      dispatch(fetchBoardEntityTypeExperience(item));
      dispatch(fetchAccreditedDirector(item));
      dispatch(fetchBoardExperienceMentor("Mentee")); // Always call with "Mentee" for board_entity_type_2
    }
  };
  const handleProgrammesChange = (item) => {
    // Program study ID is handled by react-hook-form
    // Clear validation errors when a selection is made
    if (item) {
      clearErrors("program_study_id");
    }
  };

  const initSettings = async () => {
    try {
      dispatch(getSettingData());

      const keysToRemove = ["redirectFrom", "email_verify", "tempRole", "temp_step"];
      for (const key of keysToRemove) {
        localStorage.removeItem(key);
      }

      dispatch(getAllProgrammes());

      // Fetch board-related data on initial load if user has a role
      const userId = localStorage.getItem("userId");
      if (userId) {
        // These will be called again in applyUserBasics, but it's safe to call multiple times
        dispatch(fetchCoursesCompleted());
        dispatch(fetchBoardExperience());
        dispatch(fetchBoardExperienceLevel());
        dispatch(fetchAccreditedDirector());
      }

    } catch (err) {
      console.error("Error in initSettings:", err);
    }
  };

  useEffect(() => {
    initSettings();
  }, []);



  const markComponentReady = () => {
  setTimeout(() => {
    setComponentReady(true);
    setInitialDataLoaded(true);
  }, 300);
};

const applyUserBasics = (user) => {
  setUserData(user);
  setImg({
    src: user?.image || placeholder,
    alt: "Upload an Image",
  });

  const { image, resume, ...rest } = user ?? {};
  reset(rest);

  setEmailVerifyString(user?.email_verify_string);
  setRoleId(user?.role_id);
  setUserId(user?.id);
  if (user?.dob) {
    setValue("dob", user?.dob);
    clearErrors("dob");
  }
  setDob(user?.dob);

  getObjectiveData(user?.role_id);
  registerSetting(user?.role_id);
  getExperienceData();
  
  // Fetch board-related data when user data is loaded
  if (user?.role_id === "Mentor" || user?.role_id === "Mentees") {
    dispatch(fetchCoursesCompleted());
    dispatch(fetchBoardExperience(user?.role_id));
    dispatch(fetchBoardExperienceLevel(user?.role_id));
    dispatch(fetchBoardEntityTypeExperience(user?.role_id));
    dispatch(fetchAccreditedDirector());
    dispatch(fetchBoardExperienceMentor("Mentee")); // Always call with "Mentee" for board_entity_type_2
  }
};

const applyUserDomains = (user) => {
  const main = user?.domains ? user.domains.split(",") : [];
  const sub = user?.subareas ? user.subareas.split(",") : [];

  setMainArea(main);
  setSelectedArea(sub);

  setValue("mainArea", main);
  setValue("subarea", sub);
  setValue("domains", main);

  clearErrors("mainArea");
  clearErrors("domains");
};

const applyUserExperience = (user) => {
  if (!Array.isArray(user?.experience_levels)) return;

  setExperienceData(user.experience_levels);
  const ids = user.experience_levels.map((item) => item.id);

  setExperience(ids);
  setValue("experience_levels", ids, { shouldDirty: true });
};

const applyAvailability = (user) => {
  const isAvailable = user?.user_availability === 2;

  setShowDateDiv(isAvailable ? "block" : "none");
  setValue("availability", isAvailable);

  setValue(
    "from_date",
    isAvailable
      ? checkFromDate(user?.user_availability_check?.start_time)
      : null
  );
  setValue(
    "to_date",
    isAvailable
      ? checkToDate(user?.user_availability_check?.end_time)
      : null
  );
};

const applyPreferences = (user) => {
  if (user?.mn_open_to_talk !== undefined) {
    setValue("mn_open_to_talk", !!Number(user.mn_open_to_talk));
    clearErrors("mn_open_to_talk");
  }

  if (user?.mn_loking_for_coach !== undefined) {
    setValue("mn_loking_for_coach", !!Number(user.mn_loking_for_coach));
    clearErrors("mn_loking_for_coach");
  }

  if (user?.language) {
    setValue("language", user.language.split(","));
  }

  if (user?.linkedin) {
    setValue("linkedin", user.linkedin);
  }
};

const applyBoardFields = (user) => {
  // Handle board_entity_type (multi-select)
  if (user?.board_entity_type) {
    const boardEntityTypeArray = user.board_entity_type.split(",").map(id => Number.parseInt(id.trim()));
    setValue("board_entity_type", boardEntityTypeArray);
    clearErrors("board_entity_type");
  }

  // Handle board_entity_type_2 (multi-select)
  if (user?.board_entity_type_2) {
    const boardEntityType2Array = user.board_entity_type_2.split(",").map(id => Number.parseInt(id.trim()));
    setValue("board_entity_type_2", boardEntityType2Array);
    clearErrors("board_entity_type_2");
  }

  // Handle course_completed (multi-select)
  if (user?.course_completed) {
    const courseCompletedArray = user.course_completed.split(",").map(id => Number.parseInt(id.trim()));
    setValue("course_completed", courseCompletedArray);
    clearErrors("course_completed");
  }

  // Handle accredited_director (multi-select)
  if (user?.accredited_director) {
    const accreditedDirectorArray = user.accredited_director.split(",").map(id => Number.parseInt(id.trim()));
    setValue("accredited_director", accreditedDirectorArray);
    clearErrors("accredited_director");
  }

  // Handle indicate_board_experience_level (multi-select)
  if (user?.indicate_board_experience_level) {
    const indicateBoardExperienceLevelArray = user.indicate_board_experience_level.split(",").map(id => Number.parseInt(id.trim()));
    setValue("indicate_board_experience_level", indicateBoardExperienceLevelArray);
    clearErrors("indicate_board_experience_level");
  }

  // Handle past_board_roles (multi-select creatable)
  if (user?.past_board_roles) {
    const pastBoardRolesArray = user.past_board_roles.split(",").map(role => role.trim());
    setValue("past_board_roles", pastBoardRolesArray);
    clearErrors("past_board_roles");
  }

  // Handle board_roles repeater field - parse JSON string or array back to array of objects
  // The API may return this as 'board_roles' or 'past_board_roles_data'
  const boardRolesData = user?.board_roles_data
 ;
  
  if (boardRolesData) {
    try {
      let boardRolesArray = [];
      if (typeof boardRolesData === "string") {
        // If it's a JSON string, parse it
        boardRolesArray = JSON.parse(boardRolesData);
      } else if (Array.isArray(boardRolesData)) {
        // If it's already an array, use it directly
        boardRolesArray = boardRolesData;
      }
      
      // Map the data to match our form structure (remove id field if present)
      // Use the actual is_currently_working value from API (not auto-check based on end_date)
      const formattedRoles = boardRolesArray.map(role => ({
        rep_company_name: role.rep_company_name || "",
        rep_board_title: role.rep_board_title || "",
        rep_start_date: role.rep_start_date || "",
        rep_end_date: role.rep_end_date || "",
        // Use the actual is_currently_working value from API
        is_currently_working: !!role.is_currently_working,
      }));
      
      setValue("board_roles", formattedRoles);
      clearErrors("board_roles");
    } catch (error) {
      console.error("Error parsing board_roles:", error);
      setValue("board_roles", []);
    }
  }

  // Handle single select fields
  const singleSelectFields = [
    "years_of_board_experience"
  ];

  for (const field of singleSelectFields) {
    if (user?.[field] !== undefined) {
      setValue(field, user[field]);
      clearErrors(field);
    }
  }
};

const applyFilesAndExtras = (user) => {
  setCheckBox2(!!user?.mf_certified_coach);
  setValue("mf_certified_coach", !!user?.mf_certified_coach);

  setSelectedFile(user?.image);

  setSelectedObjective(
    user?.objective ? user.objective.split(",") : []
  );

  setResumeText(
    user?.resume ? user.resume.split("resume/")[1] : ""
  );
  setSelectedResume(user?.resume);
};

  // Load user data separately
useEffect(() => {
  const loadUserData = async () => {
    if (!getUserId) {
      markComponentReady();
      return;
    }

    try {
      const res = await dispatch(fetchUserData(getUserId)).unwrap();
      const user = res?.data;

      if (user) {
        applyUserBasics(user);
        applyUserDomains(user);
        applyUserExperience(user);
        applyAvailability(user);
        applyPreferences(user);
        applyBoardFields(user);
        applyFilesAndExtras(user);
      }

      markComponentReady();
    } catch (err) {
      console.error("Error in loadUserData:", err);
      markComponentReady();
    }
  };

  loadUserData();
}, [getUserId, setting, languageOptions]);
;

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const onChangePicture = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) {
      setImg({ src: placeholder, alt: "Upload an Image" });
      setGetLoader(true);
      return;
    }

    const allowedExtensions = ["jpg", "jpeg", "png"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      setPopupMessage("Please select valid image format (jpg, jpeg, png)");
      setShowPopup(true);
      return;
    }

    // ✅ 30 MB check (STANDARDIZED)
    const sizeInMB = file.size / (1024 * 1024);
    if (sizeInMB > 30) {
      setPopupMessage("Please select image size less than 30 MB");
      setShowPopup(true);
      setImg({ src: placeholder, alt: "Upload an Image" });
      return;
    }

    clearErrors("image");

    setImg({
      src: placeholder,
      alt: file.name,
    });

    setCropImg(URL.createObjectURL(file));
    setCropImgModalShow(true);
    setGetLoader(false);
  };

  const onChangeResume = (e) => {
    if (e.target.files[0]) {
      const selectedResume = e.target.files[0];
      setSelectedResume(selectedResume);
      setResumeText(selectedResume.name);
      // Clear any validation errors for this field
      clearErrors('resume');
    }
  };

  const fileToImage = (childdata) => {
    setSelectedFile(blobToFile(childdata, getUserId + ".png"));
    setImg({
      src: URL.createObjectURL(childdata),
      alt: "",
    });
    setCropImgModalShow(false);
  };

  useEffect(() => {
    if (selectedObjective && selectedObjective.length > 0) {
      setValue("objective", selectedObjective);
      clearErrors("objective");
      trigger("objective");
    }
  }, [selectedObjective, setValue, clearErrors, trigger]);

  useEffect(() => {
    if (experienceData && Array.isArray(experienceData) && experienceData.length > 0) {
      setExperience(experienceData.map((item) => item.id));
    }
  }, [experienceData]);

  const renderField = (field) =>
    renderStudentSignupField(field, {
      control,
      register,
      errors,
      watch,
      setValue,
      clearErrors,
      trigger,
      email,
      setEmail,
      readOnly,
      showPassword,
      togglePasswordVisibility,
      email_verify_string: emailVerifyString,
      roleId,
      handleChange,
      handleProgrammesChange,
      programmes,
      programStudyId,
      university_partners_list,
      years,
      userExperience,
      country,
      userData,
      languageOptions,
      customStyles,
      industry_list,
      industryData,
      setIndustryData,
      particularProgram,
      checkBox,
      setCheckBox,
      checkBox2,
      setCheckBox2,
      availabilityChecked,
      showDateDiv,
      checkFromDate,
      checkToDate,
      fromDate,
      toDate,
      setShowDateDiv,
      onChangePicture,
      selectedFile,
      src,
      alt,
      resumeText,
      onChangeResume,
      selectedResume,
      mainArea,
      setMainArea,
      selectedArea,
      setSelectedArea,
      areas,
      selectedObjective,
      setSelectedObjective,
      objective,
      experience,
      setExperience,
      dob,
      setDob,
      countWords,
      employee: watch("employee") || "",
      // Board-related data
      coursesCompleted,
      boardExperienceMentor,
      boardEntityTypeExperience,
      accreditedDirector,
      boardExperienceLevel,
      boardExperience,
      // Settings for board_roles_validation
      setting,
    });

  return (
    <>
      {/* SkeletonLoader - show while component is not ready or data is not loaded */}
      {(!componentReady || !initialDataLoaded) && <SkeletonLoader />}

      {/* Main content - show only when component is ready and data is loaded */}
      <div style={{ display: (componentReady && initialDataLoaded) ? 'block' : 'none' }}>
        <section className="loginouter studentsteps">
          <Container>
            {registerStepFields && Array.isArray(registerStepFields) && registerStepFields.length > 0 ? (
              registerStepFields.map((resp, index) => {
                return (
                  <Form onSubmit={handleSubmit(onSubmit, () => scrollToFirstError())} className="mt-3" key={resp?.id || index}>
                    <Row className="align-items-center ">
                      <Col md={12}>
                        <div className="logininnerouter">
                          <div className="w-100">
                            <div className="loginlogo text-center mb-5 pb-4">
                              <Link to="/">
                                {setting?.logo_path && (
                                  <img 
                                    src={setting?.logo_path} 
                                    alt="logo"
                                  />
                                )}
                              </Link>
                            </div>
                            <div className="loginform" style={{ backgroundColor: 'white', padding: '20px' }}>
                              <h1>{resp?.step_label}</h1>
                              <div className="steps_signup">
                                <div>
                                  <span className="stepcount active">1</span>
                                  <span className="stepcount">2</span>
                                  <span className="stepcount">3</span>
                                  <span className="stepcount">4</span>
                                </div>
                              </div>

                              <div className="profilescreen" style={{ backgroundColor: '#f9f9f9', borderRadius: '15px', width: '100%' }}>
                                <div className="whoamform">
                                  <div
                                    className="mt-3"
                                    style={{
                                      marginTop: "0em",
                                      display: "block",
                                    }}
                                  >
                                    <Row className="align-items-center">
                                      {(() => {
                                        // Track which board role fields have been rendered
                                        let renderedBoardRoleFields = new Set();
                                        
                                        return (
                                          <>
                                            {resp?.reg_feilds && Array.isArray(resp.reg_feilds) && resp.reg_feilds.map((field, idx) => {
                                              const boardRoleFieldKeys = ['rep_company_name', 'rep_board_title', 'rep_start_date', 'rep_end_date', 'rep_label'];
                                              const isBoardRoleField = boardRoleFieldKeys.includes(field.reg_key);
                                              
                                              // Skip if already rendered as part of a group
                                              if (renderedBoardRoleFields.has(field.reg_key)) {
                                                return null;
                                              }
                                              
                                              // If this is the first board role field, render the entire group
                                              if (isBoardRoleField && field.reg_key === 'rep_company_name') {
                                                renderedBoardRoleFields.add('rep_company_name');
                                                renderedBoardRoleFields.add('rep_board_title');
                                                renderedBoardRoleFields.add('rep_start_date');
                                                renderedBoardRoleFields.add('rep_end_date');
                                                
                                                return (
                                                  <React.Fragment key="board_roles_group">
                                                    {renderBoardRolesInline(resp?.reg_feilds, {
                                                      control,
                                                      register,
                                                      errors,
                                                      watch,
                                                      setValue,
                                                      clearErrors,
                                                      trigger,
                                                      setting,
                                                      formState,
                                                    })}
                                                  </React.Fragment>
                                                );
                                              }
                                              
                                              // Skip other board role fields (they're rendered as a group)
                                              if (isBoardRoleField) {
                                                return null;
                                              }
                                              
                                              // Render normal fields
                                              return (
                                                <React.Fragment key={field.reg_key}>
                                                  {renderField(field)}
                                                </React.Fragment>
                                              );
                                            })}
                                          </>
                                        );
                                      })()}
                                    </Row>
                                  </div>
                                </div>

                                <div className="form-group mt-3 text-center">
                                  <Button
                                    className="btn loginsubmit nextbtn outline me-2"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      history(`/register?validating_string=${emailVerifyString}`);
                                    }}
                                    disabled={getLoader}
                                  >
                                    Previous
                                  </Button>
                                  <button
                                    type="submit"
                                    className="btn loginsubmit nextbtn ml-2 btn-red"
                                    disabled={getLoader}
                                  >
                                    {terminateProcess === "Yes" ? "Submit" : "Save & Next"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                );
              })
            ) : (
              <Form className="mt-3">
                <Row className="align-items-center ">
                  <Col md={12}>
                    <div className="logininnerouter">
                      <div className="w-100">
                        <div className="loginlogo text-center mb-5 pb-4">
                          <Link to="/">
                            {setting?.logo_path && (
                              <img 
                                src={setting?.logo_path} 
                                alt="logo"
                              />
                            )}
                          </Link>
                        </div>
                        <div className="loginform" style={{ backgroundColor: 'white', padding: '20px' }}>
                          <h1>Student Registration - Step 2</h1>
                          <p>Loading form fields...</p>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Container>
        </section>

        {cropImgModalShow && (
          <ImageCropper
            show={true}
            cropImg={cropImg}
            fileToImage={fileToImage}
            onHide={() => {
              setCropImgModalShow(false);
            }}
            centered={true}
            size="xl"
            className="cropper-modal"
            style={{ zIndex: 9999 }}
          />
        )}

        <PopupModalWithOk
          show={showPopup}
          onHide={() => setShowPopup(false)}
          message={popupMessage}
          showConfirm={true}
          staticBackdrop={true}
          onConfirm={handlePopupOk}
        />
      </div>
    </>
  );
};

StudentSignup.propTypes = {
  title: PropTypes.string,
  superUserParams: PropTypes.object,
};

StudentSignup.defaultProps = {
  title: "",
  superUserParams: {},
};

export default StudentSignup;